import { Link } from 'react-router-dom';
import { getNewArticles } from '@/mocks/articles';

export default function LatestSites() {
  const latest = getNewArticles();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 max-w-6xl mx-auto">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              最新收录磁力网站
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              持续发现优质磁力新站，第一时间收录到导航中。
            </p>
          </div>
          <Link
            to="/category/yingshi"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="max-w-6xl mx-auto space-y-4">
          {latest.map(site => (
            <Link
              key={site.id}
              to={`/article/${site.slug}`}
              className="group flex flex-col sm:flex-row items-start gap-4 p-5 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-full sm:w-40 h-28 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={site.thumbUrl}
                  alt={site.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="font-heading font-bold text-foreground-900 text-base group-hover:text-primary-600 transition-colors">
                    {site.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                    新收录
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500 ml-auto">
                    <i className="ri-star-fill text-amber-400 text-xs"></i>
                    {site.rating}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {site.description}
                </p>
                <div className="flex flex-wrap items-center gap-3">
                  {site.tags.map(tag => (
                    <span key={tag} className="px-2 py-0.5 rounded-md bg-background-200 text-foreground-600 text-xs">
                      {tag}
                    </span>
                  ))}
                  <span className="text-xs text-foreground-400">{site.addedDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/yingshi"
            className="flex items-center gap-1 text-sm text-primary-600 font-medium"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}